import { render, staticRenderFns } from "./EnrollReview.vue?vue&type=template&id=49c39500&scoped=true&"
import script from "./EnrollReview.vue?vue&type=script&lang=js&"
export * from "./EnrollReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c39500",
  null
  
)

export default component.exports